import { connect, useDispatch, useSelector } from "react-redux"

import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import { FaEye } from "react-icons/fa"
import TableContainer from "components/Common/DataTableContainer"
import { fetchUsers } from "../../redux/actions/user"
import servicesIcon1 from "../../assets/images/services-icon/01.png"
import servicesIcon2 from "../../assets/images/services-icon/02.png"
import servicesIcon3 from "../../assets/images/services-icon/03.png"
import servicesIcon4 from "../../assets/images/services-icon/04.png"
import user3 from "../../assets/images/users/user-3.jpg"
import Salesdonut from "./AllCharts/apex/salesdonut"
import { getAdminDashboardDataRequest } from "../../redux/actions/auth"

const Dashboard = () => {
  const history = useNavigate()
  const dispatch = useDispatch()

  const [menu, setMenu] = useState(false)

  const userState = useSelector(state => state.user)
  const [userData, setUserData] = useState([])

  const adminDashboardInfo = useSelector(state => state.auth.adminDashboardInfo)
  // const getAdminDashboardDataScreen = useSelector(state => state.screens.getAdminDashboardData)

  useEffect(() => {
    dispatch(getAdminDashboardDataRequest())
  }, [])
  

  const columns = useMemo(
    () => [
      {
        header: "Registered  Date",
        accessorKey: "signup_date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              {row.first_name + " " + row.last_name}
            </div>
          )
        }
      },
      {
        header: "Mobile Number",
        accessorKey: "mobile_no",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email ID",
        accessorKey: "email_id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "User Type",
        accessorKey: "user_type",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "View User",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div>
              <Button
                size="md"
                color="primary"
                className="w-20 text-transform"
                onClick={() => history(`/view-user/user/${row.enc_user_id}`)}
              >
                <FaEye />
              </Button>
            </div>
          )
        },
      },
    ],
    []
  )

  useEffect(() => {
    dispatch(fetchUsers({
    "page" : 1,
    "limit" : 10
}))
  }, [])

  useEffect(() => {
    if (userState && Array.isArray(userState.users)) {
      setUserData(userState.users)
    }
  }, [userState])

  useEffect(() => {
  }, [userData])

  const toggle = () => {
    setMenu(!menu)
  }
  document.title = "PULA | Admin Dashboard"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h2 className="nom-title page-title mb-3">Dashboard</h2>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    Welcome to Dashboard
                  </li>
                </ol>
              </Col>
            </Row>
          </div>
          <Row>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon1} alt="" />
                    </div>
                    <h3 className="dashboard-title font-size-16 text-uppercase mt-0 text-white-50">
                      PVS members
                    </h3>
                    <h4 className="fw-medium font-size-24">{adminDashboardInfo?.pvs_members_count}</h4>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>
                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon2} alt="" />
                    </div>
                    <h3 className="dashboard-title font-size-16 text-uppercase mt-0 text-white-50">
                      New PVS Registrations
                    </h3>
                    <h4 className="fw-medium font-size-24">{adminDashboardInfo?.new_pvs_registration_count}</h4>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon3} alt="" />
                    </div>
                    <h3 className="dashboard-title font-size-16 text-uppercase mt-0 text-white-50">
                      Pending PVS Approvals
                    </h3>
                    <h4 className="fw-medium font-size-24">{adminDashboardInfo?.pending_pvs_approval_count}</h4>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>

                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="mini-stat bg-primary text-white">
                <CardBody>
                  <div className="mb-4">
                    <div className="float-start mini-stat-img me-4">
                      <img src={servicesIcon4} alt="" />
                    </div>
                    <h3 className="dashboard-title font-size-16 text-uppercase mt-0 text-white-50">
                      Total System Users
                    </h3>
                    <h4 className="fw-medium font-size-24">{adminDashboardInfo?.system_user_count}</h4>
                  </div>
                  <div className="pt-2">
                    <div className="float-end">
                      <Link to="#" className="text-white-50">
                        <i className="mdi mdi-arrow-right h5"></i>
                      </Link>
                    </div>
                    <p className="text-white-50 mb-0 mt-1">Since last month</p>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row hidden>
            <Col xl={3}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Sales Report</h4>
                  <div className="cleafix">
                    <p className="float-start">
                      <i className="mdi mdi-calendar me-1 text-primary"></i> Jan
                      01 - Jan 31
                    </p>
                    <h5 className="font-18 text-end">$4230</h5>
                  </div>
                  <div id="ct-donut" className="ct-chart wid pt-4">
                    <Salesdonut />
                  </div>
                  <div className="mt-4">
                    <table className="table mb-0">
                      <tbody>
                        <tr>
                          <td>
                            <span className="badge bg-primary">Desk</span>
                          </td>
                          <td>Desktop</td>
                          <td className="text-end">54.5%</td>
                        </tr>
                        <tr>
                          <td>
                            <span className="badge bg-success">Mob</span>
                          </td>
                          <td>Mobile</td>
                          <td className="text-end">28.0%</td>
                        </tr>
                        <tr>
                          <td>
                            <span className="badge bg-warning">Tab</span>
                          </td>
                          <td>Tablets</td>
                          <td className="text-end">17.5%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col xl={4}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Activity</h4>
                  <ol className="activity-feed">
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 22</span>
                        <span className="activity-text">
                          Responded to need “Volunteer Activities”
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 20</span>
                        <span className="activity-text">
                          At vero eos et accusamus et iusto odio dignissimos
                          ducimus qui deleniti atque...
                          <Link to="#" className="text-success">
                            Read more
                          </Link>
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 19</span>
                        <span className="activity-text">
                          Joined the group “Boardsmanship Forum”
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 17</span>
                        <span className="activity-text">
                          Responded to need “In-Kind Opportunity”
                        </span>
                      </div>
                    </li>
                    <li className="feed-item">
                      <div className="feed-item-list">
                        <span className="date">Jan 16</span>
                        <span className="activity-text">
                          Sed ut perspiciatis unde omnis iste natus error sit
                          rem.
                        </span>
                      </div>
                    </li>
                  </ol>
                  <div className="text-center">
                    <Link to="#" className="btn btn-primary">
                      Load More
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>

            <Col xl={5}>
              <Row>
                <Col md={6}>
                  <Card className="text-center">
                    <CardBody>
                      <div className="py-4">
                        <i className="ion ion-ios-checkmark-circle-outline display-4 text-success"></i>

                        <h5 className="text-primary mt-4">Order Successful</h5>
                        <p className="text-muted">
                          Thanks you so much for your order.
                        </p>
                        <div className="mt-4">
                          <Link to="#" className="btn btn-primary btn-sm">
                            Chack Status
                          </Link>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={6}>
                  <Card className="bg-primary">
                    <CardBody>
                      <div className="text-center text-white py-4">
                        <h5 className="mt-0 mb-4 text-white-50 font-size-16">
                          Top Product Sale
                        </h5>
                        <h1>1452</h1>
                        <p className="font-size-14 pt-1">Computer</p>
                        <p className="text-white-50 mb-0">
                          At solmen va esser necessi far uniform myth...{" "}
                          <Link to="#" className="text-white">
                            View more
                          </Link>
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Card>
                    <CardBody>
                      <h4 className="card-title mb-4">Client Reviews</h4>
                      <p className="text-muted mb-3 pb-4">
                        " Everyone realizes why a new common language would be
                        desirable one could refuse to pay expensive translators
                        it would be necessary. "
                      </p>
                      <div className="float-end mt-2">
                        <Link to="#" className="text-primary">
                          <i className="mdi mdi-arrow-right h5"></i>
                        </Link>
                      </div>
                      <h6 className="mb-0">
                        {" "}
                        <img
                          src={user3}
                          alt=""
                          className="avatar-sm rounded-circle me-2"
                        />{" "}
                        James Athey
                      </h6>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <div className=" mt-4 mb-1 pb-2">
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <h2 className="nom-title mb-0">New Users</h2>
                  <Button
                    color="primary"
                    onClick={() => history("/users")}
                  >
                    View all users
                  </Button>
                </div>
              </div>
              <TableContainer
                // defaultPageSize={50}
                columns={columns}
                data={userData || []}
                // isGlobalFilter={true}
                // isPagination={true}
                // isCustomPageSize={true}
                // SearchPlaceholder="Search records..."
                // pagination="pagination"
                isAddButton={false}
                buttonClass="btn btn-primary"
                buttonName="Add User"
                handleUserClick={() => {
                  history("/add-user")
                }}
                paginationWrapper="dataTables_paginate paging_simple_numbers"
                tableClass=" table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                theadClass="table-light"
                divClassName="table-responsive mb- nominee-tbl-wrapper"
                key={userData?.length || 0}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  user: state.auth.user,
})

Dashboard.propTypes = {
  t: PropTypes.any,
}

export default connect(mapStateToProps)(Dashboard)
